function hideSubjectField() {
	const subjectFields = document.querySelectorAll('input[type="text"]');

	subjectFields.forEach(function (field) {
		if (
			field.value !== 'notrip' &&
			field.closest('.gfield_type_text') &&
			field.closest('.gfield_type_text').classList.contains('notrip')
		) {
			field.closest('.gfield_type_text').classList.remove('notrip');
		}
	});
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		hideSubjectField();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
